<template>
<div class="edit">
    <el-form ref="userinfo" :model="userinfo" :rules="rules" label-width="80px">
        <el-row>
            <el-col :lg="12">
                <el-form-item label="職稱:" prop="role">
                    <el-radio-group v-model="userinfo.role">
                        <el-radio :label="1">業務</el-radio>
                        <el-radio :label="2">美容師</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-form-item label="密碼:">
                    <el-input v-model="userinfo.password" type="password" placeholder="如不更改可不填"></el-input>

                </el-form-item>

            </el-col>
        </el-row>

        <el-row>
            <el-col :lg="8">
                <el-form-item label="品牌" prop="brand_id">
                    <el-radio-group v-model="userinfo.brand_id">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="8">
                <el-form-item label="姓名:">
                    <el-input v-model="userinfo.name"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="電話">
                    <el-input v-model="userinfo.phone"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="16">
                <el-form-item label="生日:" prop="birthday">
                    <el-date-picker v-model="userinfo.birthday" type="date" placeholder="選擇日期"></el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>

            <el-col :lg="22">
                <el-form-item label="地址:">
                    <el-select v-model="userinfo.city" placeholder="" @change="queryArea">
                        <el-option v-for="item in getCityItems" :key="item.city" :label="item.city" :value="item.city">
                        </el-option>
                    </el-select>
                    <el-select v-model="userinfo.area" placeholder="">
                        <el-option v-for="item in getAreaItems" :key="item.area" :label="item.area" :value="item.area">
                        </el-option>
                    </el-select>

                    <el-input v-model="userinfo.address" style="width:50%;"></el-input>
                </el-form-item>

            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="8">
                <el-form-item label="店櫃">
                    <el-select v-model="shop" placeholder="">
                        <el-option v-for="item in shopList" :key="item._key" :label="item.name" :value="item._key" clearable>
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click.native.prevent="addShop">增加</el-button>
                </el-form-item>

            </el-col>
            <el-col :lg="8">
                <el-table :data="shops" style="width: 100%" size="small" border>
                    <el-table-column prop="name" label="店櫃" width="auto" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="刪除" align="center">
                        <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-delete" @click.native.prevent="deleteShop(scope.$index, shops)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center">
            <el-col :lg="8">
                <el-button type="primary" @click.prevent="updateUser('userinfo')">
                    <i class="el-icon-edit"></i>修改
                </el-button>
                <el-button type="default" @click.native.prevent="backSearch">返回</el-button>
            </el-col>
        </el-row>

    </el-form>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import moment from 'moment'
import {
    async
} from 'q'
export default {
    name: 'Edit',
    props: {
        userKey: String
    },
    data() {
        return {
            shop: '',
            shops: [],
            shopList: [],
            shopInfo: [],
            userinfo: {
                name: '',
                user_id: '',
                password: '',
                phone: '',
                birthday: '',
                area: '',
                city: '',
                address: '',
                role: 0,
                shops: [],
                brand_id: 0,
            },
            password: '',
            date: '',
            rules: {
                role: [{
                    required: true,
                    message: '請點選職稱',
                    trigger: 'blur'
                }],
                brand_id: [{
                    required: true,
                    message: '請點選品牌',
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: '請輸入名字'
                }],
                phone: [{
                    required: true,
                    message: '請輸入電話'
                }],
                user_id: [{
                    required: true,
                    message: '請輸入帳號',
                    trigger: 'blur'
                }],

                birthday: [{
                    required: true,
                    message: '請輸入生日',
                    trigger: 'blur'
                }]
            },

        }
    },
    computed: mapGetters(["getShopList", "getShopDetail", "getCityItems", "getAreaItems", "UserInfo", "UserShops", "getUserError", "getUserMsg"]),

    mounted() {

    },
    created() {
        this.fetchCity()
        this.fetchUserInfo()
        this.queryShop()
    },
    methods: {
        ...mapActions(["fetchShop", "fetchShopDetail", "fetchUserInfo", "updateUser", "fetchCity", "fetchArea"]),

        async fetchUserInfo() {
            const data = await {
                _key: this.userKey
            }
            await this.$store.dispatch('fetchUserInfo', data)
                .then(() => {
                    this.userinfo = this.UserInfo
                    this.shopInfo = this.UserShops
                    this.shopInfo.forEach(shopIn => {
                        this.shops.push({
                            shops: shopIn._key,
                            name: shopIn.name
                        })
                    });
                }).catch((err) => {
                    console.log(err)
                });
        },

        updateUser: function (formName) {
            if (typeof (this.userinfo.birthday) != String) {
                this.date = moment(this.userinfo.birthday).format('YYYY-MM-DD')
            } else {
                this.date = this.userinfo.birthday
            }
            if (this.userinfo.password != '') {
                this.password = this.userinfo.password
            }
            const data = {
                _key: this.userinfo._key,
                role: this.userinfo.role,
                name: this.userinfo.name,
                phone: this.userinfo.phone,
                city: this.userinfo.city,
                area: this.userinfo.area,
                address: this.userinfo.address,
                birthday: this.date,
                user_id: this.userinfo.user_id,
                shops: this.shops,
                password: this.password,
                brand_id: this.userinfo.brand_id

            }
            if (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch('updateUser', data)
                        if (this.getUserError != true) {
                            this.$notify({
                                title: '修改成功',
                                message: ('員工資料修改成功'),
                                type: 'success'
                            })
                            this.$emit('outEdit')
                        } else {
                            this.$notify({
                                title: '失敗',
                                message: this.getUserMsg,

                            });

                        }
                    } else {
                        this.$notify({
                            title: '驗證失敗',
                            message: '表單未通過驗證',

                        });
                    }
                })
            }

        },

        queryArea: function () {
            let city = this.userinfo.city
            let cityName = {
                city
            }
            console.log(cityName);
            this.$store.dispatch('fetchArea', cityName)
        },
        queryShop: function () {
            const data = {}
            this.$store.dispatch('fetchShop', data)
                .then(() => {
                    this.shopList = this.getShopList
                }).catch((err) => {
                    console.log(err);
                });
        },
        addShop: function () {
            const data = {
                _key: this.shop
            }
            this.$store.dispatch('fetchShopDetail', data)
                .then(() => {

                    this.shops.push({
                        shops: this.shop,
                        name: this.getShopDetail.name
                    })
                }).catch((err) => {
                    console.log(err);
                });
        },
        deleteShop(index, rows) {
            rows.splice(index, 1)
        },
        backSearch: function () {
            this.$emit('back')
        }
    },
}
</script>

<style scoped>
.edit {
    font-size: 36px;
    font-weight: bold;
}
</style>
